import { uz } from "./uz";
import { ru } from "./ru";
import { oz } from "./oz";

export default {
  uz,
  ru,
  oz,
};
